<ng-template #contractTemplate>
  <vex-page-layout>
    <vex-page-layout-header class="pb-4" fxLayout="column" fxLayoutAlign="center end">
      <app-legend [legendItems]="legendData" class="-mt-6"></app-legend>
    </vex-page-layout-header>

    <vex-page-layout-content class="-mt-6">
      <div class="card overflow-auto -mt-16">
        <base-data-table-header
          [label]="entityName"
          [loading]="loading"
          [showArchives]="true"
          [showArchived]="isArchive"
          (onClearTextFilter)="clearTextFilter()"
          (onSearchChange)="onSearchChange($event)"
          (onShowArchived)="onShowArchived($event)"
          (onCreate)="createItem()"
          [createPermission]="[ENUM_PERMISSION.CREATE_CONTRACT]"
          [templates]="[
            { template: engagementTypeToggle, position: 1, place: 'after', isShowing: true },
            { template: advancedFilters, position: 2, place: 'before', isShowing: true }
          ]"
        ></base-data-table-header>

        <base-data-table
          [count]="count"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [sortField]="sortField"
          [sortOrder]="sortOrder"
          [dataSource]="dataSource"
          [displayedColumns]="displayedColumns"
          [feisColumns]="feisColumns"
          [routerLinkDetailRow]="routerLinkDetailRow"
          [stickyTop]="true"
          (onPageEvent)="pageEvent($event)"
          (onSortEvent)="sortEvent($event)"
          (onUpdateItem)="updateItem($event)"
          (onDeleteItem)="deleteItem($event)"
          (onArchiveItem)="archiveItem($event)"
        ></base-data-table>
      </div>
    </vex-page-layout-content>
  </vex-page-layout>

  <!-- Boutons radio pour filtrer entre Contrat et Devis -->
  <ng-template #engagementTypeToggle>
    <mat-radio-group [value]="filters.engagementType ?? null">
      <mat-radio-button
        #button
        class="mx-2"
        *ngFor="let type of engagementTypes"
        [value]="type.value"
        (click)="checkState(button)"
      >
        {{ type.label }}
      </mat-radio-button>
    </mat-radio-group>
  </ng-template>

  <ng-template #advancedFilters>
    <button-filter [nbFilters]="activeFiltersCount" (clickButton)="toggleSidenav()"></button-filter>
  </ng-template>
</ng-template>

<ng-template #filtersTemplate>
  <ng-container *ngIf="isFilterOpen">
    <contract-filter
      [sidenav]="sideNav"
      [filters]="filters"
      (onClear)="clearTextFilter()"
      (onFilter)="applyAdvancedFilter($event)"
    ></contract-filter>
  </ng-container>
</ng-template>

<app-sidenav #sidenav [content]="contractTemplate" [contentSidenav]="filtersTemplate"></app-sidenav>
